import React from "react";
import styles from './Real.module.css';
import improveImg from '../../assets/home/improves.png';

const Real = () =>{
    return(
        <div className="mb-5 overflow-hidden">
            <div className="row g-0">
                <div className={`col-md-6 ${styles.imgDiv}`}>
                    <img data-aos='slide-right' data-aos-offset="150" src={improveImg} alt="" className={styles.img}/>
                </div>
                <div className="col-md-6">
                    <div className={styles.text}>
                        <p data-aos='slide-right' data-aos-offset="150"  className={styles.heading}>AL RIMAL</p>
                        <p data-aos='slide-left' data-aos-offset="150" className={styles.subHeading}>Unlocking Financial Excellence and Expanding Global Influence</p>
                        <p data-aos='zoom-in' data-aos-offset="150" className={styles.content}>Through a comprehensive suite of financial planning, analysis, and strategic advisory services, Al Rimal empowers clients to optimize resource allocation, drive sustainable growth, and enhance operational efficiency. Leveraging deep industry expertise and advanced analytical tools, our consultants deliver actionable insights to navigate complex financial landscapes, mitigate risks, and capitalize on emerging global opportunities. With a commitment to integrity and innovation, Al Rimal Finance Consultancy delivers bespoke solutions that pave the way for enduring financial success and a lasting international presence. </p>
                        {/* <div data-aos='zoom-in' style={{textAlign:'left'}}>
                            <button className={`btn custom_btn ${styles.btn}`}>LET&apos;S TALK</button>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Real;